import storedPermissions from './session-data/permissions';

let cache = null;

function decode(permission) {
  const pattern = permission.url
    .replace(/\(\?P<[^>]+>/g, '(')
    .replace(/\(\\d\+\)/g, ':id');

  return { ...permission, urlPattern: new RegExp(pattern) };
}

export default {
  get() {
    if (cache === null) {
      // lazily initialize the cache on read
      const permissions = storedPermissions.get();
      cache = permissions.map(decode);
    }

    return cache;
  },

  set(permissions) {
    cache = null; // clear cache on write
    return storedPermissions.set(permissions);
  },

  clear() {
    cache = null; // clear cache on write
    return storedPermissions.clear();
  },
};
